export enum Constants {
  USER_SET_ADDRESS = 'USER_SET_ADDRESS',
  USER_SET_LOADING = 'USER_SET_LOADING',
  USER_SET_PROVIDER = 'USER_SET_PROVIDER',
  USER_SET_JSON_RPC_PROVIDER = 'USER_SET_JSON_RPC_PROVIDER',
  USER_SET_TOKEN_AMOUNT = 'USER_SET_TOKEN_AMOUNT',
  USER_SET_NATIVE_TOKEN_AMOUNT = 'USER_SET_NATIVE_TOKEN_AMOUNT',
  USER_SET_CHAIN_ID = 'USER_SET_CHAIN_ID',
  USER_SET_SDK = 'USER_SET_SDK',
  USER_SET_DASHBOARD_KEY = 'USER_SET_DASHBOARD_KEY',
  USER_SET_AUTHORIZATION_STEP = 'USER_SET_AUTHORIZATION_STEP',
  USER_SET_CONTRACTS = 'USER_SET_CONTRACTS',
  USER_SET_NFTS = 'USER_SET_NFTS',
  USER_SET_WHITELISTED = 'USER_SET_WHITELISTED',
  USER_SET_COMISSION = 'USER_SET_COMISSION',
  USER_SET_SIGNER = 'USER_SET_SIGNER',
  USER_SET_CONTRACTS_ERC20 = 'USER_SET_CONTRACTS_ERC20',
  USER_SET_TOKEN_LIST_ERC20 = 'USER_SET_TOKEN_LIST_ERC20',
  USER_SET_COUNTRIES = 'USER_SET_COUNTRIES',
  USER_SET_CONNECTOR_ID = 'USER_SET_CONNECTOR_ID',
  USER_SET_DASHBOARD_KEY_POPUP = 'USER_SET_DASHBOARD_KEY_POPUP',
  USER_SET_DASHBOARD_KEY_POPUP_CALLBACK = 'USER_SET_DASHBOARD_KEY_POPUP_CALLBACK'

}